// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRight__searchPanel":"qr_a bht_rq bht_kr bht_ks","PostDetailRight__brandDaysPosts":"qr_b bht_rq bht_kr bht_ks"};